import { findAll } from "../utils/dom";

const PlayVideo = () => {
	const videos = findAll("[js-play-video]");
	if (!videos || videos.length === 0) return;

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const video = entry.target;

			if (entry.isIntersecting) {
				video.play().catch((e) => {
					// Erro comum: autoplay bloqueado até interação do usuário
					console.warn("Autoplay falhou:", e);
				});
			} else {
				video.pause();
			}
		});
	}, {
		threshold: 0.5, // 50% do vídeo visível na tela
	});

	videos.forEach((video) => {
		observer.observe(video);

		// Adiciona controle manual no clique
		video.addEventListener("click", (e) => {
			const el = e.currentTarget;
			if (el.paused) {
				el.play();
			} else {
				el.pause();
			}
		});
	});
};

export default PlayVideo;